<template>
  <v-app>
    <v-container>
      <v-layout>
        <div class="col-xs-12">
          <h3>This page was not found!</h3>
          <br />
          <!-- <button v-if="globalVar.mode == 'normal'" class="btn btn-primary" @click="toSearch">Back to Main</button> -->
        </div>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import globalVar from './GlobalVar.js'
export default {
  data() {
    return {}
  },
  computed: {
    getCSSwith(key) {
      return this.$store.state.svrCSS[key]
    }
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    toSearch() {
      if (globalVar.mode == 'normal') {
        this.$router.replace('/')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({ name: 'Search', params: { mchdCode: mchCd } })
      }
    }
  }
}
</script>
